/** Phase A: the English passport and the first-time tutorial. */
export const enGuide = {
  passport: {
    title: '🛂 English Passport',
    tool: 'Passport',
    levels: ['Starter', 'A1 Explorer', 'A2 Traveller', 'B1 Speaker', 'B1+ Star', 'B2 Champion'],
    xp: (n: number) => `${n} XP`,
    next: (n: number) => `${n} XP to the next level`,
    top: 'Top level reached — amazing!',
    levelUp: (name: string) => `🎉 New English level: ${name}!`,
    newStamp: '🛂 New stamp in your English passport!',
    stats: {
      known: 'Words met',
      mastered: 'Mastered',
      spelled: 'Spelled',
      shadowed: 'Said aloud',
      talks: 'Role-plays',
      stories: 'Stories',
      stamps: 'Stamps',
    },
    talkStamps: 'Role-play stamps',
    placeStamps: 'Places & festivals',
    notYet: 'Not yet',
    week: 'Your last days',
    legend: { words: 'words', talks: 'talks', spells: 'spelling' },
    day: (n: number) => `D${n}`,
    parents: '👨‍👩‍👧 For grown-ups',
    parentsHint: 'What your child has practised. Words under “keep practising” come back in Review until they stick.',
    strong: 'Strong words',
    weak: 'Keep practising',
    none: 'Nothing yet',
    practise: '🎤 Go to the English corner',
    stampNames: {
      nightMarket: 'Night market',
      lantern: 'Lantern Festival',
      dragonBoat: 'Dragon Boat Festival',
      moon: 'Moon Festival',
      newYear: 'Lunar New Year',
      taipei101: 'Taipei 101',
      mrt: 'Taipei MRT',
      museum: 'Palace Museum',
      taroko: 'Taroko Gorge',
      beach: 'Qixingtan Beach',
      jiufen: 'Jiufen Old Street',
      xiangshan: "Elephant Mountain",
      ximen: "Ximending",
      longshan: "Longshan Temple",
      cks: "CKS Memorial Hall",
      beitou: "Beitou Hot Springs",
      dongdamen: "Dongdamen Night Market",
      jian: "Ji'an",
    },
  },
  tutorial: {
    skip: 'Skip',
    next: 'Next ›',
    back: '‹ Back',
    done: '▶ Let’s play!',
    menu: '❓ How to play',
    steps: [
      { title: 'Welcome!', text: 'This is your town in Taiwan. Live your school days, help people — and learn English along the way.' },
      { title: 'Walk around', text: 'Use the arrows, or just tap anywhere on the map to walk there.' },
      { title: 'Talk and use things', text: 'When you’re next to someone or something, this button lights up. Tap it to talk, buy, play…' },
      { title: 'Jump!', text: 'Hop over hedges, fences and bushes. Some secrets are only reachable with a jump.' },
      { title: 'What to do next', text: 'Your next goal is always written here, and a golden arrow on the map shows the way.' },
      { title: 'Your journal', text: 'Today’s goals, the story chapters and every quest live here. People with a ❗ over their head have something for you.' },
      { title: 'Your phone', text: 'Chats, calls, PixelBook, the radio — and every tool: English practice, the arcade, treasure hunts, your passport. Watch out for scams!' },
      { title: 'The menu', text: 'Pause, change language, turn sound off or save your game here. Have fun!' },
    ],
  },
};
